export const APIENDPOINT_AUTH = '/auth';
export const APIENDPOINT_SIGNUP = '/signup';
export const APIENDPOINT_SWITCH = '/switch';
export const APIENDPOINT_EMAIL = '/email';
export const APIENDPOINT_ME = '/me';
export const APIENDPOINT_MEMBER = '/member';
export const APIENDPOINT_COMPANIES = '/companies';
export const APIENDPOINT_USERS = '/users';
export const APIENDPOINT_COMPANY = '/company';
export const APIENDPOINT_CERTIFICATE = '/certificate';
export const APIENDPOINT_LOGIN = '/login';
export const APIENDPOINT_LOGOUT = '/logout';
export const APIENDPOINT_ACCESS_TOKEN = '/access_token';
export const APIENDPOINT_MAGIC_LINK = '/magiclink';
export const APIENDPOINT_DOCUMENTS = '/docs';
export const APIENDPOINT_DOCUMENT = '/document';
export const APIENDPOINT_DESTINATION = '/dest';
export const APIENDPOINT_DOWNLOAD = '/download';
export const APIENDPOINT_DISPLAY = '/display';
export const APIENDPOINT_CONTRACT = '/contract';
export const APIENDPOINT_DELETE = '/delete';
export const APIENDPOINT_SIGNATURE = '/signature';
export const APIENDPOINT_DESCRIPTION = '/description';
export const APIENDPOINT_AVATAR = '/avatar';
export const APIENDPOINT_UPLOAD = '/upload';
export const APIENDPOINT_UPLOAD_MULTI = '/uploadmulti';
export const APIENDPOINT_COMPANY_REGISTRATION = '/company_registration';
export const APIENDPOINT_REPRESENTATIVE = '/representative';
export const APIENDPOINT_ERESIDENCY_GRANTED = '/eresidency_granted';
export const APIENDPOINT_EXPECTED_COMPANY_DATA = '/expected_company_data';
export const APIENDPOINT_MANDATES = '/mandates';
export const APIENDPOINT_CUSTOMERS = '/customers';
export const APIENDPOINT_PAYMENTS = '/payments';
export const APIENDPOINT_INVOICE = '/invoice';
export const APIENDPOINT_PREVIEW = '/preview';
export const APIENDPOINT_INVOICES = '/invoices';
export const APIENDPOINT_PAGINATED = '/paginated';
export const APIENDPOINT_SERVICES = '/services';
export const APIENDPOINT_INVITATION = '/invitation';
export const APIENDPOINT_ZERO = '/zero';
export const APIENDPOINT_MISC = '/misc';
export const APIENDPOINT_SEARCH = '/search';
export const APIENDPOINT_SEARCH_COMPANY = '/searchcompany';
export const APIENDPOINT_RETRY_PAYMENT = '/retry';
export const APIENDPOINT_ESTIMATE = '/estimate';
export const APIENDPOINT_CONTACTS = '/contacts';
export const APIENDPOINT_SETTINGS = '/settings';
export const APIENDPOINT_BANK_ACCOUNTS = '/bank_accounts';
export const APIENDPOINT_MIGRATIONS = '/migrations';
export const APIENDPOINT_COUNTRIES = '/countries';
export const APIENDPOINT_TRANSACTIONS = '/transactions';
export const APIENDPOINT_BALANCES = '/balances';
export const APIENDPOINT_TAGS = '/tags';
export const APIENDPOINT_LINK = '/link';
export const APIENDPOINT_CONNECT = '/connect';
export const APISEND_SIGNATURE_EMAIL = '/send_signature_email';
export const APIENDPOINT_EMPLOYEES = '/employees';
export const APIENDPOINT_SALARIES = '/salaries';
export const APIENDPOINT_TRAVELS = '/travels';
export const APIENDPOINT_PACKAGES = '/packages';
export const APIENDPOINT_LETTERS = '/letters';
export const APIENDPOINT_STATS = '/stats';
export const APIENDPOINT_STATUS = '/status';
export const APIENDPOINT_NOTIFICATIONS = '/notifications';
export const APIENDPOINT_READ = '/read';
export const APIENDPOINT_OUT_OF_POCKET = '/out_of_pocket';
export const APIENDPOINT_PAYROLL = '/payroll';
export const APIENDPOINT_TICKETS = '/tickets';
export const APIENDPOINT_MESSAGES = '/messages';
export const APIENDPOINT_SOLVED = '/solved';
export const APIENDPOINT_FEEDBACK = '/feedback';
export const APIENDPOINT_PRIORITY = '/priority';
export const APIENDPOINT_NOTES = '/notes';
export const APIENDPOINT_ENTITIES = '/entities';
export const APIENDPOINT_LIST = '/list';
export const APIENDPOINT_REPORT = '/report';
export const APIENDPOINT_REPORTS = '/reports';
export const APIENDPOINT_FEATURES = '/features';
export const APIENDPOINT_KEYS = '/keys';
export const APIENDPOINT_MULTIPLE = '/multiple';
export const APIENDPOINT_TOKEN = '/token';
export const APIENDPOINT_VERIFY = '/verify';
export const APIENDPOINT_OTHER = '/other';
export const APIENDPOINT_MATCHING = '/matching';
export const APIENDPOINT_TRANSACTION_ID = '/transaction_id';
export const APIENDPOINT_ENTITY = '/entity';
export const APIENDPOINT_RISK_PROFILE_ASSESSMENT = '/risk_profile_assessment';
export const APIENDPOINT_ANNUAL_REPORTS = '/annual_reports';
export const APIENDPOINT_RETRY = '/retry';
export const APIENDPOINT_REJECT = '/reject';
export const APIENDPOINT_APPROVE = '/approve';
export const APIENDPOINT_REFERRAL_DATA = '/referral_data';
export const APIENDPOINT_REFRESH = '/refresh';
export const APIENDPOINT_DUPLICATION = '/duplicated';
export const APIENDPOINT_ACCOUNTING_REPORTS = '/accounting_reports';
export const APIENDPOINT_INTERGIRO_REQUIREMENTS = '/intergiro_requirements';
export const APIENDPOINT_METADATA = '/metadata';
export const APIENDPOINT_INVOICE_DATA = '/invoice_data';
export const APIENDPOINT_PARSE = '/parse';
export const APIENDPOINT_REQUISITES = '/requisites';
export const APIENDPOINT_SIGNED = '/signed';
export const APIENDPOINT_ALL = '/all';
export const APIENDPOINT_MONTH = '/month';
export const APIENDPOINT_YEAR = '/year';
export const APIENDPOINT_TYPE = '/type';
export const APIENDPOINT_DOCUMENT_TYPE = '/document_type';
export const APIENDPOINT_TAXES_PAID = '/taxes_paid';
export const APIENDPOINT_PENDING_PAYMENTS = '/pending_payments';
export const APIENDPOINT_GENERATE_REMOTE_CONTRACT = '/generate_remote_contract';
export const APIENDPOINT_VIRTUAL_OFFICE = '/virtual_office';
export const APIENDPOINT_REQUISITE = '/requisite';
export const APIENDPOINT_REQUIREMENTS_DONE = '/requirements_done';
export const APIENDPOINT_EXTEND = '/extend';
export const APIENDPOINT_LIKE = '/like';
export const APIENDPOINT_UNLIKE = '/unlike';
export const APIENDPOINT_START_DATE = '/start_date';
export const APIENDPOINT_END_DATE = '/end_date';
export const APIENDPOINT_EXISTING = '/existing';
export const APIENDPOINT_DAILY_ALLOWANCE = '/daily_allowance';
export const APIENDPOINT_EOR_PLATFORM = '/eor_platform';
export const APIENDPOINT_EMPLOYER = '/employer';
export const APIENDPOINT_ID = '/id';
export const APIENDPOINT_EOR_SERVICE_CONTRACT = '/eor_service_contract';
export const APIENDPOINT_REJECT_QUOTE = '/reject_quote';
export const APIENDPOINT_APPROVE_QUOTE = '/approve_quote';
export const APIENDPOINT_PAYROLLS = '/payrolls';
export const APIENDPOINT_CURRENT_MONTH = '/current_month';
export const APIENDPOINT_CONTRACTOR = '/contractor';
export const APIENDPOINT_SET_BONUS = '/set_bonus';
export const APIENDPOINT_EMPLOYEE = '/employee';
export const APIENDPOINT_OLD_EMPLOYEE = '/old_employee';
export const APIENDPOINT_TERMINATE_CONTRACT = '/terminate_contract';
export const APIENDPOINT_RESEND_SIGNATURE_EMAIL = '/resend_signature_email';
export const APIENDPOINT_CALCULATE_GROSS = '/calculate_gross';
export const APIENDPOINT_NET_SALARY = '/net_salary';
export const APIENDPOINT_CURRENCY = '/currency';
export const APIENDPOINT_COUNTRY = '/country';
export const APIENDPOINT_REQUEST_SALARY_UPDATE = '/request_salary_update';
export const APIENDPOINT_UPDATE_EMPLOYEE_DATA = '/update_employee_data';
export const APIENDPOINT_UPDATE = '/update';
export const APIENDPOINT_DATA = '/data';
export const APIENDPOINT_ADD_SECONDARY_USER = '/add_secondary_user';
export const APIENDPOINT_ENVIRONMENT = '/environment';
export const APIENDPOINT_PAYMENT = '/payment';
export const APIENDPOINT_CSV = '/csv';
export const APIENDPOINT_AMAZON = '/amazon';
export const APIENDPOINT_PRICE = '/price';
export const APIENDPOINT_CRISP = '/crisp';
export const APIENDPOINT_CATEGORIES = '/categories';
export const APIENDPOINT_ARTICLES = '/articles';
export const APIENDPOINT_SECTIONS = '/sections';
export const APIENDPOINT_APPEAL = '/appeal';
export const APIENDPOINT_PLAN = '/plan';
export const APIENDPOINT_PREMIUM = '/premium';
export const APIENDPOINT_PAYMENT_INTENT = '/payment_intent';
export const APIENDPOINT_CLIENT_SECRET = '/client_secret';
export const APIENDPOINT_DATE = '/date';
export const APIENDPOINT_JOBS = '/jobs';
export const APIENDPOINT_REPLACE = '/replace';
export const APIENDPOINT_RESTORE = '/restore';
export const APIENDPOINT_CONVERT = '/convert';
export const APIENDPOINT_SALES = '/sales';
export const APIENDPOINT_VALIDATE_VAT = '/validate_vat';
export const APIENDPOINT_PAYMENT_METHOD = '/payment_method';
export const APIENDPOINT_PAYMENT_METHODS = '/payment_methods';
export const APIENDPOINT_SET_PAYMENT_METHOD = '/set_primary_payment_method';
export const APIENDPOINT_REGISTRATIONS = '/registrations';
export const APIENDPOINT_SETUP_INTENT_SECRET = '/setup_intent_secret';
export const APIENDPOINT_PERMISSIONS = '/permissions';
export const APIENDPOINT_PAYONEER_API = '/payoneer_api';
export const APIENDPOINT_STATEMENTS = '/statements';
export const APIENDPOINT_BANK_RECONNECT = '/bank_reconnect';
export const APIENDPOINT_PROFIT = '/profit';
export const APIENDPOINT_LOSS = '/loss';
export const APIENDPOINT_MISSING_DOCUMENTS_OPTIONS = '/missing_documents_options';
export const APIENDPOINT_OTHER_DOCUMENTS = '/other_documents';
export const APIENDPOINT_REQUISITE_ALL_DONE = '/done';
export const APIENDPOINT_DECLINE_STATEMENT_DOCUMENT = '/decline_statement_document';
export const APIENDPOINT_DECLINED_DOCUMENT = '/declined_document';
export const APIENDPOINT_CONTRACTORS = '/contractors';
export const APIENDPOINT_DATA_EXTRACTION = '/data_extraction';
export const APIENDPOINT_REGENERATE = '/regenerate';
export const APIENDPOINT_FEEDBACK_APP = '/feedback_app';
export const APIENDPOINT_SEND = '/send';
export const APIENDPOINT_CANCEL = '/cancel';
export const APIENDPOINT_DELETE_EOR_EMPLOYEE = '/delete_eor_employee';
export const APIENDPOINT_BUSINESS_TRIP_DOC = '/business_trip_doc';
export const APIENDPOINT_PURCHASE_INVOICE = '/purchase_invoice';
export const APIENDPOINT_PROOF_OF_PAYMENT = '/proof_of_payment';
export const APIENDPOINT_DROPBOX_EMAIL = '/dropbox_email/';
export const APIENDPOINT_SUGGEST_DROPBOX_EMAIL = '/suggest_dropbox_email';
export const APIENDPOINT_CREATE_CUSTOM_EMAIL = 'create_personalised_dropbox_email';
export const APIENDPOINT_SALES_CSV_UNSUCCESSFUL = '/sales_csv_unsuccessful';
export const APIENDPOINT_LOAN_AGREEMENT = '/loan_agreement';
export const APIENDPOINT_CALCULATE_TOTAL_LOAN = '/calculate_total_loan';
export const APIENDPOINT_MEMBER_LEND_COMPANY = '/member_lend_company';
export const APIENDPOINT_BORROW_FROM_COMPANY = '/borrow_from_company';
export const APIENDPOINT_LEND_TO_COMPANY = '/lend_to_company';
export const APIENDPOINT_TRANSACTION = '/transaction';
export const APIENDPOINT_CERTIFICATE_EXPIRATION_REMINDER = '/eresidency_reminder';
export const APIENDPOINT_PROJECTS = '/projects';
export const APIENDPOINT_PARSED_DOCUMENTS = '/parsed';
export const APIENDPOINT_REMOVE_INVOICE = '/remove_invoices';
export const APIENDPOINT_ASSIGN_INVOICES = '/assign_invoices';
export const APIENDPOINT_SALES_INVOICE = '/sales_invoice';
export const APIENDPOINT_NET_SETTLEMENT = '/net_settlement';
export const APIENDPOINT_CHECK_IF_SHOULD_BE_MATCHED_WITH_DOCUMENT =
  '/check_if_should_be_matched_with_document';
export const APIENDPOINT_POPULATED = '/populated';
export const APIENDPOINT_INVOICE_TEMPLATE = '/invoice_template';
export const APIENDPOINT_TERMS_AND_CONDITIONS = '/terms_and_conditions';
export const APIENDPOINT_BANKS = '/banks';
export const APIENDPOINT_TYPES = '/types';
export const APIENDPOINT_INVESTMENT_ACCOUNT = '/investment_account';
export const APIENDPOINT_ASK_CHANGE = '/ask_change';
export const APIENDPOINT_BULK = '/bulk';
export const APIENDPOINT_POA_STATUS = '/update_poa';
export const APIENDPOINT_TERMINATE_CONTRACTOR = '/terminate_contractor';
export const APIENDPOINT_DATE_RANGE = '/date_range';
export const APIENDPOINT_INTERNAL = '/internal';
export const APIENDPOINT_BY_TYPE = '/by_type';
export const APIENDPOINT_TAG = '/tag';
export const APIENDPOINT_COMPANION = '/companion';
export const APIENDPOINT_FILES = '/files';
export const APIENDPOINT_ENABLE_INVOICE_REMINDER = '/enable_invoice_reminder';
export const APIENDPOINT_REMOVE_INVOICE_REMINDER = '/remove_invoice_reminder';
export const APIENDPOINT_MISSING_TRANSACTIONS_OPTIONS = '/missing_transactions_options';
export const APIENDPOINT_OTHER_DOCUMENTS_OPTIONS = '/other_documents_options';
export const APIENDPOINT_REQUISITE_TYPE_DOCUMENTS = '/documents';
export const APIENDPOINT_PAYONEER = '/payoneer';
export const APIENDPOINT_KRAKEN = '/kraken';
export const APIENDPOINT_ASSOCIATE_INVOICE_CONTRACTOR = '/associate_invoice_contractor';
export const APIENDPOINT_DOC_ID = '/doc_id';
export const APIENDPOINT_CHECK_ASSOCIATION_BETWEEN_INVOICE_AND_CONTRACTOR =
  '/check_association_between_invoice_and_contractor';
export const APIENDPOINT_DETACH_INVOICE_FROM_CONTRACTOR = '/detach_invoice_from_contractor';
export const APIENDPOINT_WORKFLOWS = '/workflows';
export const APIENDPOINT_METRIC = '/metric';
export const APIENDPOINT_PERSONAL_EXPENSE_REFUND = '/personal_expense_refund';
export const APIENDPOINT_REFUNDED_SALE = '/refunded_sale';
export const APIENDPOINT_REFUNDED_PURCHASE = '/refunded_purchase';
export const APIENDPOINT_PHONE = '/phone';
export const APIENDPOINT_RESEND_CODE = '/resend_code';
export const APIENDPOINT_CONFIRM = '/confirm';
export const APIENDPOINT_REGISTER = '/register';
export const APIENDPOINT_FIRST_ACCESS = '/first_access';
export const APIENDPOINT_WITH_COMPANY_EMPLOYEES = '/with_company_employees';
export const APIENDPOINT_REMOVE_INVOICES_MULTIPLE = '/remove_invoices_multiple';
export const APIENDPOINT_COMMENT = '/comment';
export const APIENDPOINT_ANNUAL_REPORT_FIRST_ACCESS = '/annual_report_first_access';
export const APIENDPOINT_EXPIRED_PASSPORTS = '/check_expired_passports';
export const APIENDPOINT_MEMBERS = '/members';
export const APIENDPOINT_DELETE_PERSONALISED_DROPBOX_EMAIL = '/delete_personalised_dropbox_email';
export const APIENDPOINT_CHECK_IF_CONTRACTOR_EMAIL_IS_ALREADY_REGISTERED =
  '/check_if_contractor_email_is_already_registered';
export const APIENDPOINT_CHECK_IF_EOR_EMPLOYEE_EMAIL_IS_ALREADY_REGISTERED =
  '/check_if_eor_employee_email_is_already_registered';
export const APIENDPOINT_VERIFY_PAYMENT = '/verify_payment';
export const APIENDPOINT_PAYMENT_PAYMENT_ID = '/payment_id';
export const APIENDPOINT_READ_MANY_BY_IDS = '/read_many_by_ids';
export const APIENDPOINT_VAT_RATE = '/vat/vat_rates';
export const APIENDPOINT_VAT_CHECK = '/vat-check';
export const APIENDPOINT_UPDATE_VAT = '/update_vat';
export const APIENDPOINT_PAYMENT_INFO = '/payment_info';
export const APIENDPOINT_UPDATE_BLACKLIST_PAYMENT_METHODS = '/update_blacklist_payment_methods';
export const APIENDPOINT_NOTIFY_ACCOUNT_HOLDER_MISMATCH = '/notify_account_holder_mismatch';
export const APIENDPOINT_SEND_ACCOUNTANT_STATUS_CONFIRMATION =
  '/send_accountant_status_confirmation';
export const APIENDPOINT_FORCE_TERMINATE_CONTRACTOR = '/force_terminate_contractor';
export const APIENDPOINT_EXPORT = '/export';
export const APIENDPOINT_UNSUPPORTED_COUNTRIES = '/unsupported_countries';
export const APIENDPOINT_MARKETPLACE = '/marketplace';
export const APIENDPOINT_MISSING_BANKS = '/missing_banks';
